<template>
  <div class="form-add">
        <h2>Agregar</h2>
        <div class="form-add__input-text">
            <label for="descripcion-input">Descripcion: </label>
            <input class="input-text" type="text" id="descripcion-input" v-model="newProduct.descripcion">

            <label for="precio-input">Precio: </label>
            <input class="input-text" type="number" id="precio-input" v-model="newProduct.precio">
        </div>

        <input
        type="file"
        name="product"
        id="product"
        accept="image/png, image/jpeg"
        @change="onFileSelected($event)"
        />
        
        <img class="form-add__image" :src="changeImage || newProduct.imageUrl" alt="">
        <button v-if="changeImage != null" @click="removeImage">Remove</button>
        <div class="add-tags">
            <h3 class="add-tags__title">Tags</h3>
            <input @keyup.enter="addTag(newTag)" v-model="newTag" class="add-tags__input-tag input-text" type="text" placeholder="+ Add a tag and press Enter">
            <ul class="add-tags__list">
                <li v-for="(tag,index) in newProduct.tags" :key="tag+index">{{tag}} <span class="add-tags__remove" @click="removeTag(tag)">x</span></li>
            </ul>
        </div>
        <button class="button" @click="onUpload" type="button">Actualizar</button>
  </div>
</template>

<script>
import { storageRef, storage } from "../main";
import { getAuth } from "firebase/auth"
import gql from "graphql-tag";
export default {
    name:"EditProduct",
    data(){
        return{
            editProduct: this.$route.params.product,
            file: null,
            newTag: null,
            changeImage: null,
            newProduct: {
                id: this.$route.params.id,
                descripcion: this.$route.params.descripcion,
                imageUrl: this.$route.params.imageUrl,
                precio: this.$route.params.precioP,
                tags: this.$route.params.tags,
            }
        }
    },
    props:{
        product: Object,
    },
    methods:{
        removeImage(){
            this.changeImage = null;
            this.file = null;
        },
        onFileSelected(event) {
            if(event.target.files[0] != null){
                this.file = event.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(this.file);
                reader.onload = (e) => {
                    this.changeImage = e.target.result;
                };
            };
        },
        removeTag(tag){
            let index = this.newProduct.tags.indexOf(tag);
            if(index !== -1){
                this.newProduct.tags.splice(index,1);
            }
        },
        addTag(tag){
            if(tag !== null && tag !== "" && !this.newProduct.tags.includes(tag)){
                this.newProduct.tags.push(tag);
                this.newTag = "";
            }
        },
        generateName() {
            return "col_" + Math.random().toString(36).substr(2, 9);
        },
        async generateNameWithExtension(name) {
            let extension = name.split(".")[1];
            let exist = true;
            let fileName = null;
            while (exist) {
                try {
                let name = this.generateName();
                fileName = name + "." + extension;
                await storageRef.child("productos").child(fileName).getDownloadURL();
                } catch (error) {
                exist = false;
                }
            }
            return fileName;
        },

        async onUpload() {
            const auth = getAuth();
            if(this.file != null){
                let fileNameGenerated = await this.generateNameWithExtension(
                    this.file.name
                );
                try {
                    await storageRef
                    .child("productos")
                    .child(fileNameGenerated)
                    .put(this.file);
                    let urlDescarga = await storageRef
                    .child("productos")
                    .child(fileNameGenerated)
                    .getDownloadURL();
                    this.newProduct.imageUrl = urlDescarga;
                } catch (error) {
                    console.log(error);
                }
            }
            this.updateProduct();
        },

        updateProduct(){
            this.$apollo.mutate({
                mutation: gql`
                mutation UpdateProduct($productId: String!, $productInput: ProductInput) {
                updateProduct(productId: $productId, productInput: $productInput) {
                    id
                    descripcion
                    imageUrl
                    precio
                    tags
                    }
                }
                `,
                variables:{
                    productId: this.newProduct.id,
                    productInput: {
                        descripcion: this.newProduct.descripcion,
                        imageUrl: this.newProduct.imageUrl,
                        precio: parseInt(this.newProduct.precio),
                        tags: this.newProduct.tags,
                    }
                }
            })
            .then((res)=>{
                alert("Actualizado")
                this.$router.push({name:'Home'})
            })
            .catch((err)=>{
                console.error(err);
            })
        }
    }
}
</script>

<style lang="scss">

</style>